import { render, staticRenderFns } from "./ModulePrimaryIssPageSrp.vue?vue&type=template&id=7a041602&"
import script from "./ModulePrimaryIssPageSrp.vue?vue&type=script&lang=js&"
export * from "./ModulePrimaryIssPageSrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports